import React, {useContext, useEffect} from "react";
import {GlobalContext} from "../../stores/GlobalStore";
import useCheckExpiration from "./useCheckExpiration";


const ExpirationChecker = (props) => {
    const isExpiredCheck = useCheckExpiration();
    const {state} = useContext(GlobalContext);

    useEffect(() => {
        state.product.isLoaded && !state.error.isError && isExpiredCheck();
    }, [state.product.isLoaded, state.error.isError, isExpiredCheck]);

    return <>{props.children}</>;
};

export default ExpirationChecker;
